import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import React, { useState, memo } from "react";
import { Link } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
const styles = {
    root: {
        width: "100%",
        paddingLeft: " 0px",
    },
    heading: {
        fontSize: "20px",
        fontWeight: 400,
        fontFamily: "Halyard Display",
        lineHeight: "24px",
    },
    firstSessionModalHeading: {
        fontSize: "14px",
        fontFamily: "Halyard Display",
        lineHeight: "22px",
    },
    description: {
        fontSize: "16px",
        fontFamily: "Halyard",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    firstSessionModalDescription: {
        fontSize: "14px",
        fontFamily: "Halyard Display",
        lineHeight: "22px",
    },
    first: {
        borderTop: "1px solid rgba(0, 0, 0, 0.12)",
        bgcolor: "#f2eee9",
        p: 30,
    },
    firstSessionModal: {
        backgroundColor: "#f2eee9",
        borderTop: "1px solid #D6D6D6",
        borderbottom: "1px solid #D6D6D6",
        paddingLeft: " 0px",
    },
    last: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
};
const minus = (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M16 8L0 8", stroke: "#333333", strokeWidth: "2" }) }));
const plus = (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M8 0V16", stroke: "#333333", strokeWidth: "2" }), _jsx("path", { d: "M16 8L0 8", stroke: "#333333", strokeWidth: "2" })] }));
function GainfulAccordion(props) {
    const [expanded, setExpanded] = useState("");
    const handleChange = (panel, item) => (event, newExpanded) => {
        if (props.trackAccordionEvent) {
            props.trackAccordionEvent(item, newExpanded);
            setExpanded(newExpanded ? panel : false);
        }
        else {
            setExpanded(newExpanded ? panel : false);
        }
    };
    return (_jsx("div", { style: styles.root, children: props.items.map((item, i) => (_jsxs(Accordion, { square: props.square && true, expanded: expanded === `panel${i}`, onChange: handleChange(`panel${i}`, item), style: styles.firstSessionModal
                ? styles.firstSessionModal
                : i === 0
                    ? styles.first
                    : i === props.items.length - 1
                        ? styles.last
                        : {}, className: props.className ? props.className : "", children: [_jsx(AccordionSummary, { expandIcon: expanded === `panel${i}` ? (_jsx("div", { className: "expand-icon", children: minus })) : (_jsx("div", { className: "expand-icon", children: plus })), "aria-controls": "panel1a-content", id: `panel1a-header${1}`, children: _jsx(Typography, { styles: props.firstSessionModalHeading ? styles.firstSessionModalHeading : styles.heading, children: item.title }) }), item.body.includes("---") ? (item.body.split("---").map((it) => (_jsx(AccordionDetails, { style: props.firstSessionModalDescription ? styles.firstSessionModalDescription : styles.description, children: it }, it.split()[0])))) : item.body.includes("Great question") ? (_jsx(AccordionDetails, { style: props.firstSessionModalDescription ? styles.firstSessionModalDescription : styles.description, children: _jsxs("span", { children: [item.body.split("Product Use Guide")[0], " ", _jsx(Link, { style: { textDecoration: "underline" }, to: "/app/howtolp/", children: "Product Use Guide" }), item.body.split("Product Use Guide")[1]] }) })) : Array.isArray(item.body) ? (_jsx(AccordionDetails, { className: props.firstSessionModalDescription ? styles.firstSessionModalDescription : styles.description, children: _jsx("div", { children: item.body.map((p) => (_jsx(Typography, { paragraph: true, children: p }, p))) }) })) : (_jsx(AccordionDetails, { style: props.firstSessionModalDescription ? styles.firstSessionModalDescription : styles.description, children: item.body }))] }, item.title))) }));
}
export default memo(GainfulAccordion);
